import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Receipt-Check--Streamline-Flex"
    >
        <desc>{'Receipt Check Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="receipt-check--shop-shopping-pay-payment-store-cash-bill-receipt-check-confirm">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.2978 0.5H3.71678c-0.93983 0 -1.77057 0.64646 -1.91803 1.59359 -0.48444 3.11157 -0.32403 6.88095 0.07307 10.28011 0.09618 0.8234 1.0513 1.1871 1.66724 0.6462l1.29497 -1.1373 0.99451 1.1057c0.61644 0.6853 1.67675 0.6818 2.28885 -0.0076l0.975 -1.0981 1.34131 1.166c0.6133 0.5332 1.5582 0.1762 1.6597 -0.6395 0.4181 -3.36292 0.6181 -7.31362 0.0879 -10.38476C12.0232 1.10853 11.2091 0.5 10.2978 0.5Z"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m4.85205 7.16442 1.56214 1.61095c0.73508 -2.11158 1.34727 -3.03816 2.73374 -4.29588"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
